<template>
  <v-card class="elevation-card rounded-12">
    <v-card-title class="font-weight-700 fs-14 lh-14 primary pa-4 white--text">
      <!--          <v-icon color="primary" class="mr-2">-->
      <!--            mdi-web-->
      <!--          </v-icon>-->
      <div>
        <v-icon color="white" class="mr-3">mdi-web</v-icon>
        <!--        <v-img-->
        <!--          src="@/assets/images/icon/location.png"-->
        <!--          width="18"-->
        <!--          height="22"-->
        <!--          class="mr-2"-->
        <!--        ></v-img>-->
      </div>
      <span class="fs-14 font-weight-bold white--text">
        Progress Tracking
      </span>
      <v-spacer />
    </v-card-title>

    <v-divider />

    <div class="text-center pa-5" v-if="loading">
      <v-progress-circular color="primary" indeterminate />
    </div>

    <template v-else>
      <v-card-text v-if="!steps.length" class="fs-14 font-weight-regular pa-4">
        No data available
      </v-card-text>
      <v-card
        v-else
        flat
        color="transparent"
        class="overflow-x-auto px-4 rounded-0"
      >
        <div class="mb-4" v-if="isRejected">
          <v-alert
            color="info"
            rounded
            class="fs-12 py-2 mt-3 mb-0 white--text"
          >
            <v-row align="center" justify="space-between" no-gutters>
              <v-col cols="auto" class="font-weight-bold">
                Your Request Has Been Rejected. Reason:
              </v-col>
              <v-col cols="auto">
                <v-btn @click="showReason = !showReason" color="white" icon>
                  <v-icon>mdi-chevron-{{ showReason ? 'up' : 'down' }}</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-alert>
          <v-slide-y-transition>
            <div v-if="showReason">
              <div class="px-4 py-4 fs-12" v-html="reason"></div>
              <v-divider />
            </div>
          </v-slide-y-transition>
        </div>

        <VuePerfectScrollbar :settings="scrollSettings">
          <v-row align="baseline" class="flex-nowrap">
            <v-col
              cols="6"
              sm="3"
              v-for="(step, index) in steps"
              :key="index"
              class="text-center"
            >
              <div class="font-weight-bold fs-12 mb-3 bluedarken--text">
                {{ step.status || '&nbsp;' }}
              </div>
              <div class="relative step-divider-container mb-3">
                <v-avatar
                  v-if="step.complete"
                  color="bluedarken"
                  class="avatar-step"
                >
                  <v-icon color="white" large class="fs-24">mdi-check</v-icon>
                </v-avatar>
                <v-avatar v-else class="avatar-step avatar-step-incomplete">
                </v-avatar>
                <v-divider
                  :key="index"
                  v-if="index + 1 < steps.length"
                  class="divider-step"
                  :class="{ bluedarken: step.complete }"
                />
              </div>
              <div class="fs-12 font-weight-bold">
                {{ step.name }}
              </div>
              <div class="fs-12 font-weight-bold">
                {{ step.email }}
              </div>
              <v-chip
                outlined
                color="primary"
                class="fs-10 mx-auto font-weight-bold rounded-3 mt-2 mb-2"
                v-if="step.date"
              >
                {{ step.date }}
              </v-chip>
            </v-col>
          </v-row>
        </VuePerfectScrollbar>
      </v-card>
    </template>
  </v-card>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar';

export default {
  name: 'card-progress-tracking',
  components: {
    VuePerfectScrollbar
  },
  props: {
    formRequest: {
      type: Object
    },
    steps: {},
    loading: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    scrollSettings: {
      maxScrollbarLength: 340
    },
    showReason: false
  }),
  computed: {
    isRejected() {
      return this.formRequest.local_status.toLowerCase() === 'rejected';
    },
    rejectItem() {
      return this.formRequest.approvals.find(
        item => item.status === 'Rejected'
      );
    },
    reason() {
      const reason = this.rejectItem?.reason;

      if (!reason) return 'There is no comment available.';

      return atob(reason);
    }
  }
};
</script>

<style>
.relative {
  position: relative;
}

.divider-step {
  border-width: 4px !important;
  position: absolute;
  width: 100%;
  top: 20px;
  left: 50%;
  z-index: 1;
}

.step-divider-container {
}

.avatar-step {
  z-index: 3;
}

.avatar-step-incomplete {
  border: 6px solid #e7e7e7 !important;
  background-color: white;
}
</style>
